import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import withStyles from 'isomorphic-style-loader/withStyles';

import { Button, Modal } from 'react-bootstrap';
import { Header, Title, Body } from 'react-bootstrap/lib/Modal';

import Tooltip from '../Tooltip';

import s from './ModalDialog.css';

/*
 *  The presentational component of the gene selection button UI. Clicking on the button
 *  will bring up a modal dialog to add/remove genes from the current selection
 */
class ModalDialog extends Component {
  static propTypes = {
    // Text of the button. If null, the button text will be the gene symbols
    buttonText: PropTypes.any,

    buttonClass: PropTypes.string,

    buttonStyle: PropTypes.string,

    buttonTooltip: PropTypes.string,

    title: PropTypes.string,

    // Should the component be disabled
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    buttonStyle: 'primary',
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  render() {
    return (
      <div className={this.props.className} style={{ ...this.props.style }}>
        <Tooltip text={this.props.buttonTooltip}>
          <Button
            disabled={this.props.disabled}
            className={this.props.buttonClass}
            bsStyle={this.props.buttonStyle}
            onClick={() => this.setState({ isOpen: true })}
          >
            {this.props.buttonText}
          </Button>
        </Tooltip>
        <Modal
          dialogClassName={s.genesDialog}
          show={this.state.isOpen && !this.props.disabled}
          onHide={() => this.setState({ isOpen: false })}
        >
          <Header closeButton>
            <Title>{this.props.title}</Title>
          </Header>
          <Body>{this.props.children}</Body>
        </Modal>
      </div>
    );
  }
}

export default withStyles(s)(ModalDialog);
